
import { Loader2 } from "lucide-react";
import { Card } from "@/components/ui/card";

export const LoadingState = () => {
  return (
    <Card className="w-full h-64 bg-white border border-[#CCCCCC]">
      <div className="flex h-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#3BAFDA]" />
      </div>
    </Card>
  );
};
